module.exports = __webpack_public_path__ + "img/VsLotion4.d2dc7129.jpg";